/**
 * Pushes data to the dataLayer
 * @param {Object} data
 */
export const push = (data) => {
  const dataLayer = (window.dataLayer = window.dataLayer || [])
  dataLayer.push(data)
}
